export class IconSetting {
  public static googleIcon = true;
}
